import { useSelector } from "react-redux";

import EbookPage from "./EbookPage";
import PhonicsStepPage from "./phonics/PhonicsStepPage";
import BookSyntaxPage from "./syntax/BookSyntaxPage";
import VocabularyPage from "../vocabulary/VocabularyPage";

// 리더스북 단어(2026-10-20 지인에듀 5판 단어장): 단어테스트와 같은 섹션이라 그 화면을 그대로 쓴다
const VOCABULARY_SECTION_TYPE_LIST = ["study", "matching", "exam"];

// 리더스북(지인에듀, 2026-10-17). 섹션은 모두 전자책(ebook) 유형이다. 파닉스북(2026-10-19)은 단계마다 섹션이 따로다.
// ipa_quiz: ECHO 발음기호 기호 테스트(api assignment/ipa_course.py)
const PHONICS_STEP_PAGE_LIST = ["mouth", "story", "speak", "quiz", "ipa_quiz"];

const ReadersBookPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  // 파닉스북의 입모양 · 이야기 듣기 · 문제 섹션(책 넘겨 보기는 phonics_step 이 book 이라 EbookPage 로 간다)
  if (section?.type === "ebook" && PHONICS_STEP_PAGE_LIST.includes(section.question?.phonics_step)) {
    return <PhonicsStepPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }
  // 구문분석(2026-10-20): 지문분석 구문분석 화면을 책 톤으로 입혀 쓴다(BookSyntaxPage)
  if (VOCABULARY_SECTION_TYPE_LIST.includes(section?.type)) {
    return <VocabularyPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }
  if (section?.type === "syntax_analysis") {
    return <BookSyntaxPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }
  if (section?.type === "ebook") {
    return <EbookPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }
  return null;
};

export default ReadersBookPage;
